import { List as CounterpartyOrdersList } from './List';

export default CounterpartyOrdersList;
